import { useTranslation } from 'react-i18next';
import { fromNewDateFormatToDDMMYYYYSlash } from './dateHelper';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

export function GetOrderPaletInfoForOrderInfoTable(productionOrderLine) {
    const { t } = useTranslation();

    let rows = [];

    rows = [
        createData(t('Packaging'), ((productionOrderLine !== null && productionOrderLine !== undefined && productionOrderLine !== false) ? productionOrderLine.QuantityFactor : '-')),
        createData(t('N° of packages'), ((productionOrderLine !== null && productionOrderLine !== undefined && productionOrderLine !== false) ? productionOrderLine.Quantity : '-')),
        createData(t('Manual'), ((productionOrderLine !== null && productionOrderLine !== undefined && productionOrderLine !== false) ? (productionOrderLine.Manual ? <CheckCircleOutlineIcon/> : <CancelOutlinedIcon/> ) : '-')),
        // createData(t('Pallet pattern'), "")
    ];


    function createData(name, info) {
        return { name, info };
    }

    return rows;
}

export function GetProductPaletInfoForOrderInfoTable(product) {
    const { t } = useTranslation();

    let rows = [];

    rows = [
        createData(t('Packaging'), ((product !== null && product !== undefined && product !== false) ? product.PackagingFactor : '-')),
        createData(t('UOM'), ((product !== null && product !== undefined && product !== false) ? product.Uom : '-')),
        // createData(t('Manual'), ((product !== null && product !== undefined && product !== false) ? (product.manual ? <CheckCircleOutlineIcon/> : <CancelOutlinedIcon/> ) : '-')),
        // createData(t('Pallet pattern'), "")
    ];


    function createData(name, info) {
        return { name, info };
    }

    return rows;
}

export function GetPalletInfoTable(palletInfo) {
    const { t } = useTranslation();
    var tempExpirationDate = '';

    if (palletInfo) { // this will check for both null and undefined
    if (palletInfo.ProductionOrderFinishedOn) {
        const finishedOnDate = new Date(palletInfo.ProductionOrderFinishedOn);
        if (!isNaN(finishedOnDate)) { // Ensure the date is valid
            tempExpirationDate = new Date(finishedOnDate); // Create a copy to avoid mutation of original date
            tempExpirationDate.setMonth(tempExpirationDate.getMonth() + (palletInfo.StorageLifeInMonths || 0)); // Safeguard StorageLifeInMonths
        } else {
            console.error("Invalid ProductionOrderFinishedOn date.");
            tempExpirationDate = null; // or set to a default value based on your use case
        }
    } else {
        console.warn("ProductionOrderFinishedOn is null or undefined.");
        tempExpirationDate = null; // Handle case where ProductionOrderFinishedOn is missing
    }
}

    const rows = [
        createData(t('Product nr.'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? palletInfo.ProductCode : "-"),
        createData(t('Description'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? palletInfo.ProductNameNL : "-"),
        createData(t('Expiration date'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? fromNewDateFormatToDDMMYYYYSlash(tempExpirationDate) : "-"),
        createData(t('Status'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? palletInfo.Status : "-"),
        // createData(t('Batchnr. productie'), "")
    ];

    function createData(name, info) {

        return { name, info };
    }

    return rows;
}

export function GetProductInfoTable(palletInfo) {
    const { t } = useTranslation();
    var tempExpirationDate = '';

    if (palletInfo !== null && palletInfo !== undefined) {
        tempExpirationDate = new Date(palletInfo.productionOrderFinishedOn);
        tempExpirationDate.setMonth(tempExpirationDate.getMonth() + palletInfo.storageLifeInMonths);
    }

    const rows = [
        createData(t('Product nr.'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? palletInfo.Description : "-"),
        createData(t('Description'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? palletInfo.NameNL : "-"),
        // createData(t('Expiration date'), (palletInfo !== null && palletInfo !== undefined && palletInfo !== false) ? palletInfo.storageLifeInMonths : "-"),
        // createData(t('Batchnr. productie'), "")
    ];

    function createData(name, info) {

        return { name, info };
    }

    return rows;
}


